import React from 'react';
import { Inbox } from 'lucide-react';

export const EmptyState = ({ icon: Icon = Inbox, title = 'Nothing here yet', description, action }) => (
  <div className="text-center py-16 px-6 border border-dashed rounded-2xl bg-secondary/40" data-testid="empty-state">
    <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-background border mb-4">
      <Icon className="h-5 w-5 text-muted-foreground" />
    </div>
    <h3 className="font-heading font-semibold text-foreground">{title}</h3>
    {description && <p className="mt-1 text-sm text-muted-foreground max-w-sm mx-auto">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
